import { useState, useEffect, useContext, createContext } from "react";
import { useHttpClient } from "../hooks/http-hook";
import { preloadImages } from "../utils/preloadImages";

const CocktailsContext = createContext();

export const CocktailsProvider = ({ children }) => {
  const [loadedCocktails, setLoadedCocktails] = useState();
  const [loadedImages, setLoadedImages] = useState();

  const { sendRequest } = useHttpClient();

  useEffect(() => {
    const fetchCocktails = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/cocktails/getAllCocktails`,
        );
        setLoadedCocktails(responseData.cocktails);

        const imagePaths = responseData.cocktails.map(
          (cocktail) => cocktail.image,
        );
        const images = preloadImages(imagePaths);

        setLoadedImages(images);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCocktails();
  }, [sendRequest]);

  return (
    <CocktailsContext.Provider value={{ loadedCocktails, loadedImages }}>
      {children}
    </CocktailsContext.Provider>
  );
};

export const useCocktails = () => {
  return useContext(CocktailsContext);
};
